/**
 * Copyright Highway9 Networks Inc.
 *
 * App wrapper around shared `@h9/ui-lib` fetch configuration.
 */

import { configureFetch as configureSharedFetch, realFetch } from "@h9/ui-lib";
import { authenticationService } from "~/services";

export { realFetch };

export function configureFetch() {
  configureSharedFetch({
    fakeBackendModulePath: "/src/helpers/config/fake-backend.ts",
    getCurrentUser: () => authenticationService.currentUserValue,
    logout: () => authenticationService.logout(),
    apiProxyUrl: import.meta.env.H9_API_PROXY_URL,
    isDev: import.meta.env.DEV,
  });
}
